import React from 'react'
import BusinessProfileSection from '../../components/User/MerchantOnboard/BusinessProfile';

const OnBoardBusiness = () => {
  return (
    <BusinessProfileSection />
  )
}

export default OnBoardBusiness;